export default __webpack_public_path__ + "static/media/home.6ec4857c.svg";